import BlackBanner from "./UI/BlackBanner";

export default BlackBanner